import React, { useState, useEffect } from "react";
import styles from "../styles/navbar.module.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkLogin = () => {
      const userData = localStorage.getItem("userData");
      setIsLoggedIn(!!userData);
    };
    checkLogin();
  }, [location]);

  const handleHashLink = (e, hash) => {
    if (location.pathname === "/") {
      e.preventDefault();
      const element = document.getElementById(hash.substring(1));
      if (element) {
        const navbarHeight = 64;
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - navbarHeight - 10;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      navigate(`/${hash}`);
    }
  };

  const handleHomeLink = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navContainer}>
        <Link to="/" className={styles.navLogo} onClick={handleHomeLink}>
          <img
            src="/icon1.ico"
            alt="Job Assistant Logo"
            className={styles.logoImage}
          />
          <div className={styles.logoText}>
            <span className={styles.logoJob}>Job</span>
            <span className={styles.logoAssistant}>Assistant</span>
          </div>
        </Link>

        <div className={styles.navMenu}>
          <Link to="/" className={styles.navLink} onClick={handleHomeLink}>
            Home
          </Link>

          <a
            href="/#how-it-works"
            className={styles.navLink}
            onClick={(e) => handleHashLink(e, "#how-it-works")}
          >
            How It Works
          </a>
          <a
            href="/#features"
            className={styles.navLink}
            onClick={(e) => handleHashLink(e, "#features")}
          >
            Features
          </a>

          <a
            href="/#pricing"
            className={styles.navLink}
            onClick={(e) => handleHashLink(e, "#pricing")}
          >
            Pricing
          </a>
        </div>

        <div className={styles.navActions}>
          {isLoggedIn ? (
            <button
              onClick={() => navigate("/dashboard")}
              className={`${styles.navButton} ${styles.navButtonPrimary}`}
              title="Go to your dashboard"
            >
              <i className="fas fa-tachometer-alt" aria-hidden="true"></i>{" "}
              Dashboard
            </button>
          ) : (
            <>
              {/* <Link
                to="/login"
                className={`${styles.navButton} ${styles.navButtonPrimary}`}
                title="Login to your account"
              >
                Login
              </Link> */}
              <Link
                to="/login"
                className={`${styles.navButton} ${styles.navButtonPrimary}`}
                title="Login to your account"
              >
                Try Now Free
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
